function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.579 14.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 155.07a.397.397 0 0 0-.396-.398h-4.498a.397.397 0 1 0 0 .794h4.498a.397.397 0 0 0 .397-.397M177.204 159.17h-2.381a.397.397 0 1 0 0 .794h2.38a.397.397 0 1 0 0-.794M177.204 156.172h-2.91a.397.397 0 1 0 0 .794h2.91a.397.397 0 1 0 0-.794M177.204 157.671h-3.969a.397.397 0 1 0 0 .794h3.969a.397.397 0 1 0 0-.794",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-457.856 -410.967)scale(2.65866)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu2.56a59df62300a4798a3472243fd53162.svg";
export { ForwardRef as ReactComponent };